import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import "./HeaderHome.css";
import Logo from "../../Assets/Svg/Header/MilkyLogo.svg";
import LogoBlue from "../../Assets/Svg/Header/MilkyLogoBlue.svg";
import ButtonContactAr from "../ButtonContact/ButtonContactAr";
import ProductMain from "../../Assets/images/Header/ProductHMain.webp";
import ProductH1 from "../../Assets/images/Header/ProductH1.webp";
import ProductH2 from "../../Assets/images/Header/ProductH2.webp";
import ProductH3 from "../../Assets/images/Header/ProductH3.webp";
// import ProductH4 from "../../Assets/images/Header/ProductH4.webp";
import IconLang from "../../Assets/Svg/Header/IconLang.svg";
import IconLangBlue from "../../Assets/Svg/Header/IconLangBlue.svg";
import HeaderArrow from "../../Assets/Svg/Header/H_Arrow_Close.svg";
import HeaderArrowBlue from "../../Assets/Svg/Header/ArrowBlue.svg";
import { RoutesAr } from "../Hooks/RoutesDynamic/RoutesDynamic";
export default function ArHomeHeader() {
  const [showDropdown, setShowDropdown] = useState(null);
  const [hoveredImage, setHoveredImage] = useState(ProductMain);
  const location = useLocation();
  const navigate = useNavigate();

  const [isScrolled, setIsScrolled] = useState(false);
  const currentPath = window.location.pathname;

  const isActive = (path) => currentPath === path;

  useEffect(() => {
    const handleScroll = () => {
      const scrollThreshold = window.innerHeight * 0.95;
      if (window.scrollY > scrollThreshold) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const handleLanguageSwitch = () => {
    const currentPath = location.pathname;
    const isArabic = currentPath.includes("/ar");

    if (isArabic) {
      const basePath = currentPath.slice(0, -3);

      const newPath = basePath === "" ? "/" : basePath;

      navigate(newPath, { replace: true });
    }
  };
  return (
    <>
      <div dir="rtl">
        <div className={`${isActive("/ar") ? "Header_Main_Container" : ""} ${isScrolled ? "scrolled_link" : ""}`}>
          <div className="Header_Container">
            <div className="Logo">
              <Link to={RoutesAr.Home}>
                <img src={isScrolled ? LogoBlue : Logo} alt="Logo" className="Header_Logo" />
              </Link>
            </div>
            <div className="Menu">
              <div
                className={`Menu_Text_Ar TFut16PxPCUC Dropdown_Container ${isScrolled ? "scrolled_link_TextAr scrolled_link_Text2" : ""}`}
                onMouseEnter={() => setShowDropdown("AboutUs")}
                onMouseLeave={() => setShowDropdown(null)}
              >
                عن الشركة <img src={isScrolled ? HeaderArrowBlue : HeaderArrow} alt="" className="HeaderArrow" />
                {showDropdown === "AboutUs" && (
                  <div className="About_Dropdown_Menu About_Dropdown_MenuAr">
                    <Link to={RoutesAr.OurStory} className="Dropdown_ItemAr TFut16PxPCUC">
                      قصتنا
                    </Link>
                    <Link to={RoutesAr.OurValues} className="Dropdown_ItemAr TFut16PxPCUC">
                      القيم الخاصة بنا
                    </Link>
                    {/* <Link to={ROUTESAR.BoardMembers} className="Dropdown_ItemAr TFut16PxPCUC">
                      أعضاء مجلس الإدارة
                    </Link> */}
                  </div>
                )}
              </div>
              <div
                className={`Menu_Text_Ar TFut16PxPCUC Dropdown_Container ${isScrolled ? "scrolled_link_TextAr scrolled_link_Text2" : ""}`}
                onMouseEnter={() => setShowDropdown("OurBrands")}
                onMouseLeave={() => {
                  setShowDropdown(null);
                  setHoveredImage(ProductMain);
                }}
              >
                علامتنا التجارية <img src={isScrolled ? HeaderArrowBlue : HeaderArrow} alt="" className="HeaderArrow" />
                {showDropdown === "OurBrands" && (
                  <div className="Product_Dropdown_Menu Product_Dropdown_MenuAr">
                    <div className="Dropdown_LeftAr">
                      <Link to={RoutesAr.TheMilkman} className="Dropdown_ItemAr TFut16PxPCUC PDDI" onMouseEnter={() => setHoveredImage(ProductH1)}>
                        ذا ميلك مان
                      </Link>
                      <Link to={RoutesAr.Reefy} className="Dropdown_ItemAr TFut16PxPCUC" onMouseEnter={() => setHoveredImage(ProductH2)}>
                        ريفي
                      </Link>
                      {/* <Link to={RoutesAr.FindOurProducts} className="Dropdown_ItemAr TFut16PxPCUC" onMouseEnter={() => setHoveredImage(ProductH4)}>
                        منافذ البيع
                      </Link> */}
                      <Link to={RoutesAr.Recipes} className="Dropdown_ItemAr TFut16PxPCUC" onMouseEnter={() => setHoveredImage(ProductH3)}>
                        الوصفات
                      </Link>
                    </div>
                    <div className="Dropdown_Right">
                      <img src={hoveredImage} alt="Brand Preview" className="Dropdown_Image" />
                    </div>
                  </div>
                )}
              </div>
              <div
                className={`Menu_Text_Ar TFut16PxPCUC Dropdown_Container ${isScrolled ? "scrolled_link_TextAr scrolled_link_Text2" : ""}`}
                onMouseEnter={() => setShowDropdown("ProductJourney")}
                onMouseLeave={() => setShowDropdown(null)}
              >
                رحلة المنتجات <img src={isScrolled ? HeaderArrowBlue : HeaderArrow} alt="" className="HeaderArrow" />
                {showDropdown === "ProductJourney" && (
                  <div className="Journey_Dropdown_Menu Journey_Dropdown_MenuAr TFut16PxPCUC">
                    <Link to={RoutesAr.MilkysFarm} className="Dropdown_ItemAr TFut16PxPCUC">
                      مزرعة ميلكيز
                    </Link>
                    <Link to={RoutesAr.MeetTheCows} className="Dropdown_ItemAr TFut16PxPCUC">
                      تعرف على الأبقار
                    </Link>
                    <Link to={RoutesAr.OurFactory} className="Dropdown_ItemAr TFut16PxPCUC">
                      مصنعنا
                    </Link>
                    <Link to={RoutesAr.Logistics} className="Dropdown_ItemAr TFut16PxPCUC">
                      الخدمات اللوجستية
                    </Link>
                  </div>
                )}
              </div>
              <Link to={RoutesAr.Csv} className={`Menu_Text_Ar TFut16PxPCUC ${isScrolled ? "scrolled_link_TextAr scrolled_link_Text2" : ""}`}>
                القيمة المشتركة
              </Link>
              <Link to={RoutesAr.Careers} className={`Menu_Text_Ar TFut16PxPCUC ${isScrolled ? "scrolled_link_TextAr scrolled_link_Text2" : ""}`}>
                المهن
              </Link>
            </div>
            <div className="Language">
              <div className="Header_Languages" onClick={() => setShowDropdown(!showDropdown)}>
                <div className="Header_Languages_Main">
                  <h4
                    className={`Language_Dropdown_Text TFut16PxPCUC ${isScrolled ? "scrolled_link_Text scrolled_link_TextAr" : ""}`}
                    onClick={handleLanguageSwitch}
                  >
                    English <img src={isScrolled ? IconLangBlue : IconLang} alt="" className="IconLang" />
                  </h4>
                </div>
              </div>
              <div>
                <ButtonContactAr isScrolled={isScrolled} Text="تواصل معنا" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="BlurSection"></div>
      <div className="BlurSection2"></div>
      <div className="BlurSection3"></div>
    </>
  );
}
